module.exports = __webpack_public_path__ + "img/google.20ef48f0.png";